import { useNavigate } from 'react-router-dom'
import { useUIStore } from '@/store/ui'

export function ImpersonationBanner() {
  const viewingAs = useUIStore((s) => s.viewingAs)
  const setViewingAs = useUIStore((s) => s.setViewingAs)
  const navigate = useNavigate()

  if (!viewingAs) return null

  function exit() {
    setViewingAs(null)
    navigate('/admin')
  }

  return (
    <div className="impersonation-banner">
      <span className="impersonation-banner__label">
        Viewing as <strong>{viewingAs.display_name}</strong>, {viewingAs.city_state}
      </span>
      <button className="impersonation-banner__exit" onClick={exit}>
        ← Exit to Admin
      </button>
    </div>
  )
}
